// extracted by mini-css-extract-plugin
export default {"hidden":"PageMessage_hidden__gOXzM","subMessages":"PageMessage_subMessages__ZAXj7"};